import { Selection } from '@atlaskit/editor-prosemirror/state';
import { createCommand, getPluginState } from '../plugin-factory';
import { ACTIONS } from '../states';
export function insertInlineSuggestion() {
  return createCommand(function () {
    return {
      type: ACTIONS.CLEAR_INLINE_SUGGESTION
    };
  }, function (tr, state) {
    var _getPluginState = getPluginState(state),
      inlineSuggestion = _getPluginState.inlineSuggestion;
    if (!inlineSuggestion) {
      return tr;
    }
    tr.replaceWith(inlineSuggestion.from, inlineSuggestion.to, inlineSuggestion.suggestedNode);
    tr.setSelection(Selection.near(tr.doc.resolve(inlineSuggestion.from + inlineSuggestion.suggestedNode.nodeSize)));
    return tr;
  });
}
export function clearSuggestion() {
  return createCommand(function () {
    return {
      type: ACTIONS.CLEAR_INLINE_SUGGESTION
    };
  });
}
export function updateInlineSuggestion(inlineSuggestion, decorationSet) {
  return createCommand(function () {
    return {
      type: ACTIONS.UPDATE_INLINE_SUGGESTION,
      payload: {
        inlineSuggestion: inlineSuggestion,
        decorationSet: decorationSet
      }
    };
  });
}
export function updateLocale(locale) {
  return createCommand(function () {
    return {
      type: ACTIONS.UPDATE_LOCALE,
      payload: {
        locale: locale
      }
    };
  });
}